export default __webpack_public_path__ + "static/media/lock.a08eff26.svg";